import { motion } from "framer-motion";

function CarSilhouette({ className = "" }) {
  return (
    <svg viewBox="0 0 240 92" className={className} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ filter: "drop-shadow(0 0 14px rgba(226,232,240,0.18))" }}>
      <path d="M18 66 C34 62 44 58 54 51 C66 39 84 31 106 29 C132 27 152 34 164 45 C176 51 190 55 200 59 C210 61 216 63 218 67" />
      <path d="M18 68 L54 68" />
      <path d="M77 68 L165 68" />
      <path d="M191 68 L218 68" />
      <circle cx="65" cy="68" r="12" />
      <circle cx="65" cy="68" r="4.5" />
      <circle cx="178" cy="68" r="12" />
      <circle cx="178" cy="68" r="4.5" />
      <path d="M74 47 C86 38 98 34 110 33 L116 48" />
      <path d="M74 47 L116 48" />
    </svg>
  );
}

function Glow() {
  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_115%,rgba(212,175,55,0.12),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,rgba(226,232,240,0.05),transparent_55%)]" />
    </div>
  );
}

function Badge({ children }) {
  return (
    <span className="px-3.5 py-1.5 rounded-full text-[11px] font-semibold tracking-wide bg-[#D4AF37]/10 text-[#E5C378] border border-[#D4AF37]/35 shadow-[0_0_20px_rgba(212,175,55,0.08)]">
      {children}
    </span>
  );
}

export default function ComingSoonCard({ settings = {}, banner = false }) {
  const badge = settings.soon_badge || "მალე დაემატება";
  const title = settings.soon_title || "ავტოპარკი იზრდება";
  const text = settings.soon_text || "ახალი ავტომობილები მალე დაემატება კატალოგს";

  if (banner) {
    return (
      <motion.article
        data-testid="coming-soon-banner"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.45 }}
        aria-disabled="true"
        className="md:col-span-2 lg:col-span-3 rounded-2xl border border-dashed border-[#D4AF37]/30 bg-[#10121A]/70 overflow-hidden cursor-default select-none"
      >
        <div className="relative flex flex-col sm:flex-row items-center gap-7 sm:gap-12 px-7 py-10 sm:px-14 sm:py-12">
          <Glow />
          <CarSilhouette className="relative w-48 sm:w-60 shrink-0 text-gray-100" />
          <div className="relative text-center sm:text-left flex-1">
            <Badge>{badge}</Badge>
            <h3 className="text-2xl sm:text-3xl font-semibold text-gray-100 mt-5 tracking-tight">{title}</h3>
            <p className="text-gray-400/90 text-[15px] mt-2.5 leading-relaxed max-w-xl">{text}</p>
          </div>
          <span className="relative shrink-0 inline-flex items-center justify-center px-9 py-3.5 rounded-full border border-white/10 text-gray-500 text-sm font-medium tracking-wide">
            მალე
          </span>
        </div>
      </motion.article>
    );
  }

  return (
    <motion.article
      data-testid="coming-soon-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
      aria-disabled="true"
      className="rounded-2xl border border-dashed border-[#D4AF37]/28 bg-[#10121A]/70 overflow-hidden flex flex-col cursor-default select-none"
    >
      <div className="relative h-60 flex items-center justify-center px-8">
        <Glow />
        <CarSilhouette className="relative w-56 text-gray-100" />
        <span className="absolute top-4 left-4">
          <Badge>{badge}</Badge>
        </span>
      </div>
      <div className="p-7 flex flex-col flex-1 justify-between border-t border-white/5">
        <div>
          <h3 className="text-2xl font-semibold text-gray-100 tracking-tight">{title}</h3>
          <p className="text-gray-400/90 text-sm mt-2.5 leading-relaxed">{text}</p>
        </div>
        <span className="mt-7 w-full inline-flex items-center justify-center py-3.5 rounded-full border border-white/10 text-gray-500 text-sm font-medium tracking-wide">
          მალე
        </span>
      </div>
    </motion.article>
  );
}
